var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSlidericon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 150.936,
    height: 150.936,
    viewBox: "0 0 150.936 150.936",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -0.289,
    y1: -0.209,
    x2: 0.742,
    y2: 0.674,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1c6bf6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9204f1"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_111",
    x: 0,
    y: 0,
    width: 150.936,
    height: 150.936,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: 7,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#a7cafd",
    floodOpacity: 0.729
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_269",
    "data-name": "Group 269",
    transform: "translate(-321.5 -2838)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 321.5, 2838)",
    filter: "url(#Rectangle_111)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_111-2",
    "data-name": "Rectangle 111",
    width: 94,
    height: 94,
    rx: 30,
    transform: "translate(13 68.47) rotate(-45)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_186",
    "data-name": "Group 186",
    transform: "translate(848.83 2527.869)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_311",
    "data-name": "Path 311",
    d: "M-441.823,389.982c0,1.55-.009,3.022.015,4.493,0,.142.186.335.334.412.612.32,1.237.619,1.869.9a.859.859,0,0,1,.562.887c-.007,2.2.139,1.962-1.861,1.962q-7.379,0-14.758,0c-.939,0-.949-.1-1.05-1.04-.124-1.152.219-1.9,1.389-2.177,1.223-.294,1.6-1.062,1.447-2.295a26.118,26.118,0,0,1-.025-3.141h-.853q-5.9,0-11.806,0c-1.961,0-2.77-.811-2.77-2.763q0-13.149,0-26.3c0-1.96.816-2.789,2.752-2.789h37.431c1.9,0,2.751.842,2.752,2.725q0,13.216,0,26.432c0,1.855-.837,2.691-2.709,2.693q-5.937.006-11.873,0Zm14.375-6.362v-.745q0-11,0-22c0-1.308-.364-1.674-1.663-1.674H-466.6c-1.309,0-1.673.361-1.673,1.663q0,11,0,22v.756Zm-25.363,11.09h9.893v-4.688h-9.893Zm7.076-8A1.764,1.764,0,0,0-447.455,385a1.759,1.759,0,0,0-1.713,1.779,1.726,1.726,0,0,0,1.75,1.659A1.737,1.737,0,0,0-445.735,386.71Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_312",
    "data-name": "Path 312",
    d: "M-412.609,526.155h14.955a1.733,1.733,0,0,1,.662.037c.169.075.389.309.376.455a.86.86,0,0,1-.384.525c-.125.085-.347.034-.525.034H-427.7c-.178,0-.4.05-.525-.036a.864.864,0,0,1-.383-.53c-.011-.145.214-.377.385-.451a1.758,1.758,0,0,1,.662-.035Z",
    transform: "translate(-35.255 -145.471)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_313",
    "data-name": "Path 313",
    d: "M-412.641,381.5h14.881a1.581,1.581,0,0,1,.661.031.872.872,0,0,1,.451.529c.02.131-.257.363-.446.454a1.483,1.483,0,0,1-.6.026q-14.948,0-29.9-.005c-.411,0-1.033.186-1.058-.479-.027-.727.623-.551,1.056-.552Q-420.115,381.494-412.641,381.5Z",
    transform: "translate(-35.226 -20.219)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_314",
    "data-name": "Path 314",
    d: "M-254.174,428.446c0,.826.014,1.652,0,2.478a2.891,2.891,0,0,1-2.722,2.863,2.852,2.852,0,0,1-3.047-2.424,25.45,25.45,0,0,1-.09-3.006c-.011-.826-.006-1.652,0-2.478,0-.385.106-.8.568-.706.2.041.464.46.471.713.043,1.651.015,3.3.028,4.956a1.813,1.813,0,0,0,1.123,1.753,1.778,1.778,0,0,0,1.894-.224,1.9,1.9,0,0,0,.744-1.638c-.006-1.5,0-2.992,0-4.488,0-.179-.057-.394.023-.527a3.463,3.463,0,0,1,.534-.572c.159.207.444.406.456.622C-254.144,426.658-254.174,427.552-254.174,428.446Z",
    transform: "translate(-181.209 -58.025)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_315",
    "data-name": "Path 315",
    d: "M-425.616,428.514c0-.871-.033-1.745.022-2.613a.857.857,0,0,1,.457-.653c.439-.086.523.3.523.663,0,1.676-.013,3.352.007,5.027a1.914,1.914,0,0,0,1.624,2,1.824,1.824,0,0,0,1.959-1.08,2.6,2.6,0,0,0,.168-.972c.017-1.519.007-3.039.008-4.558,0-.179-.054-.4.028-.526.127-.2.347-.461.533-.466a.688.688,0,0,1,.48.483c.029,1.854.08,3.712-.022,5.561a2.859,2.859,0,0,1-2.935,2.5,2.865,2.865,0,0,1-2.829-2.681c-.041-.892-.008-1.787-.008-2.681Z",
    transform: "translate(-37.841 -58.102)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_316",
    "data-name": "Path 316",
    d: "M-364.218,427.953c.447-.86.841-1.632,1.25-2.4.192-.36.349-.9.907-.6.494.267.219.692.038,1.05-.471.936-.966,1.86-1.4,2.811a1.066,1.066,0,0,0,0,.788c.454,1.016.951,2.015,1.454,3.009.195.385.2.756-.223.867a.917.917,0,0,1-.732-.423c-.471-.824-.865-1.692-1.345-2.659-.481.941-.905,1.764-1.322,2.59-.17.337-.364.681-.8.479-.5-.229-.295-.613-.12-.963.476-.957.975-1.9,1.412-2.88a1.167,1.167,0,0,0,0-.851c-.423-.957-.907-1.887-1.37-2.827-.183-.371-.4-.792.113-1.031s.691.219.87.579c.327.658.646,1.321.976,1.978C-364.447,427.622-364.347,427.751-364.218,427.953Z",
    transform: "translate(-88.847 -57.772)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_317",
    "data-name": "Path 317",
    d: "M-306.7,406.16c-.372.993-.7,1.869-1.028,2.746l-3.733,9.959c-.047.125-.056.3-.146.367a6.022,6.022,0,0,1-.732.387c-.077-.264-.286-.574-.212-.783.662-1.871,1.374-3.725,2.073-5.583q1.283-3.413,2.57-6.825a1.35,1.35,0,0,1,.252-.537.72.72,0,0,1,.574-.194C-306.9,405.761-306.8,406.025-306.7,406.16Z",
    transform: "translate(-135.733 -41.172)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_318",
    "data-name": "Path 318",
    d: "M-200.287,429.633c0-1.184-.028-2.37.023-3.552.011-.254.285-.675.485-.705.441-.067.56.321.56.722q0,3.553,0,7.106c0,.4-.083.76-.549.756s-.524-.384-.522-.773C-200.283,432-200.287,430.817-200.287,429.633Z",
    transform: "translate(-232.942 -58.216)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlidericon1);
export default __webpack_public_path__ + "static/media/slidericon1.9342a5e8108b37ec5649d423d5fdbb09.svg";
export { ForwardRef as ReactComponent };